import { render, staticRenderFns } from "./EcotypeDetail.vue?vue&type=template&id=539199ea&scoped=true"
import script from "./EcotypeDetail.vue?vue&type=script&lang=js"
export * from "./EcotypeDetail.vue?vue&type=script&lang=js"
import style0 from "./EcotypeDetail.vue?vue&type=style&index=0&id=539199ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539199ea",
  null
  
)

export default component.exports